import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { showAuthMessage, iniciaDashboardPresencaSucesso } from "actions/Presenca";
import {
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  INICIA_DASHBOARD_PRESENCA,
  BUSCA_DASHBOARD_PRESENCA,
  INICIA_DASHBOARD_PRESENCA_SUCESSO,
  BUSCA_DASHBOARD_PRESENCA_SUCESSO
} from 'constants/ActionTypes';
/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

export function* iniciaAcoesPresenca() {
  yield takeEvery(INICIA_DASHBOARD_PRESENCA, fnIniciaPresenca);
}

export function* buscaPresencaEdicao() {
  yield takeEvery(BUSCA_DASHBOARD_PRESENCA, fnBuscaPresencaEdicao);
}

/*#################################################################################################################*/
/* ------------------------------------------ Funções das Sagas ---------------------------------------------------*/

function* fnIniciaPresenca() {
  try {
    const retorno = {
   // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  serieCarregada: null,
  locaisControladosEscola: [],
  idLocalControladoFixado: null,
  
};//yield call(getPresencas);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      console.log('fnIniciaPresenca', retorno)
      yield put(iniciaDashboardPresencaSucesso(retorno));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fnBuscaPresencaEdicao({ payload }) {
  try {
    yield put(buscaPresencaEdicao(payload));
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export default function* rootSaga() {
  yield all([
    fork(iniciaAcoesPresenca),
    fork(buscaPresencaEdicao)
  ]);
}